<template>
    <div>
        <!-- banner -->
        <div class="banner">
            <div class="b-left">
                <div class="b-tit">打造校园一脸通行场景 <br /> 建设企业数字化新平台</div>
                <div class="b-tip">公司专注于数智化管理平台的建设，通过大数据、人工智能与教育及政企行业的深度融合，<br />打造数智化管理平台，为客户提供数据共建共享的应用及服务</div>
                <div @click="goProductDetail" class="b-detail">了解详情</div>
            </div>
            <img class="b-img" src="https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/banner2.png" />
        </div>
        <!-- 建设企业数字化新平台 -->
        <div class="digital-platform">
            <div class="plat-tit">建设企业数字化新平台</div>
            <div class="plat-list">
                <div @click="platClick(index)" v-for="(item, index)  in platList" :key="'plat-list' + index"
                    class="plat-item" :class="index == activePlat ? 'p-i-ac' : ''">
                    <img :src="item.img" alt="">
                    <div class="">{{ item.name }}</div>
                </div>
            </div>
            <div v-if="index == activePlat" class="plat-content" v-for="(item, index) in platContent"
                :key="'plat-content' + index">
                <div class="plat-left">
                    <img :src="item.img" alt="">
                </div>
                <div class="plat-right">
                    <div class="p-r-tit"><span style="color: #0267FE;">{{ item.name }}</span>{{ item.tit }}</div>
                    <div class="p-r-tip">{{ item.tip }}</div>
                    <div class="b-detail" @click="goEduCase(1, index)">了解详情</div>
                </div>
            </div>
        </div>
        <!-- 一脸通行 -->
        <div class="face-box">
            <div class="f-tit">打造校园一脸通行全场景</div>
            <div class="f-con">
                <div class="f-left">
                    <div class="f-l-tit">全部场景</div>
                    <div class="f-l-list">
                        <div @click="faceItemClick(index)" :class="actveFaceIndex == index ? 'face-ac' : ''"
                            v-for="(item, index ) in faceList" :key="'f-l-list' + index" class="f-l-item">{{ item }}</div>
                    </div>
                </div>
                <div class="f-center" v-for="(item, index) in faceContent" :key="'f-center' + index"
                    v-if="actveFaceIndex == index">
                    <div class="f-c-t">
                        <div class="f-c-t-tit">{{ item.tit }}</div>
                        <div class="f-c-t-tip">{{ item.tip }}</div>
                    </div>
                    <div class="f-c-c" v-html="item.con"></div>
                    <div class="b-detail" @click="goEduCase(0, index)">了解详情</div>
                </div>
                <img v-if="actveFaceIndex == index" v-for="(item, index ) in faceImgList" :key="'b-detail' + index"
                    :src="item" class="f-r" alt="">
            </div>
        </div>
        <!-- 认可 -->
        <div class="user-box">
            <div class="user-tit">众多用户的一致认可</div>
            <div class="user-list-box">
                <el-carousel :autoplay="true" arrow="never" indicator-position="outside">
                    <el-carousel-item v-for="(ret, retIndex) in userBox" :key="retIndex">
                        <div class="user-list">
                            <div @click="userItemClick(item, index)" class="user-item" v-for="(item, index) in ret.userList"
                                :key="'user-item' + index">
                                <img :src=item.img alt="">
                                <div class="tip-list">
                                    <div :style="{ backgroundColor: v.bg }" v-for="(v, i) in item.tipList" :key="i"
                                        class="tip-item">{{
                                            v.tip }}
                                    </div>
                                </div>
                                <div class="user-name">{{ item.name }}</div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <!-- 合作伙伴-->
        <div class="partner-box">
            <div class="partner-tit">合作伙伴</div>
            <!-- <div class="partner-list"> -->
            <vue-seamless-scroll :data="newsList" :class-option="classOption" class="seamless-warp">
                <!-- <div class="partner-item" v-for="(item, index) in partnerList" :key="'partner-item' + index">
                    <img :src="item" alt="">
                </div> -->
                <ul class="item">
                    <img v-for="item in newsList" :src="item.title" />
                </ul>
            </vue-seamless-scroll>
            <vue-seamless-scroll :data="newsList2" :class-option="classOption2" class="seamless-warp">
                <!-- <div class="partner-item" v-for="(item, index) in partnerList" :key="'partner-item' + index">
                    <img :src="item" alt="">
                </div> -->
                <ul class="item">
                    <img v-for="item in newsList2" :src="item.title" />
                </ul>
            </vue-seamless-scroll>
            <!-- </div> -->
        </div>
        <!-- 滚动test -->
        <!-- <vue-seamless-scroll :data="listData" :class-option="classOption" class="seamless-warp">
            <ul class="item">
                <li v-for="item in listData">
                    <span class="title" v-text="item.title"></span><span class="date" v-text="item.date"></span>
                </li>
            </ul>
        </vue-seamless-scroll> -->
        <!-- 首页弹窗 -->
<!--        <el-dialog class="dia-log" title="" :close-on-click-modal="false" :show-close="false" :visible.sync="dialogVisible">-->
<!--            <img class="dia-log-img" src="https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/home-open.gif"-->
<!--                alt="">-->
<!--            <img @click="dialogClose" class="close-img" src="@/assets/close.png" alt="">-->
<!--        </el-dialog>-->
    </div>
</template>
<script>
export default {
    name: 'Index',
    data() {
        return {
            newsList: [{
                'title': require('@/assets/hz.png'),
            }],
            newsList2: [{
                'title': require('@/assets/hz2.png'),
            }],
            dialogVisible: true,
            carousel_height: '550px',
            platList: [ // 建设企业数字化新平台列表
                {
                    name: '宜搭(企小域)',
                    img: 'https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/qxy.png'
                },
                {
                    name: '专属钉钉',
                    img: ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/dd.png')
                },
                {
                    name: 'Teambition',
                    img: ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/tea.png')
                },
                {
                    name: 'Chat AI',
                    img: ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/ai.png')
                }

            ],
            platContent: [
                {
                    name: '宜搭(企小域)',
                    tit: '——助力生产力创新、加速数字化转型',
                    tip: '企小域是基于宜搭搭建的低代码产品，致力为企业提供流程化的企业管理，通过审批流程、报表搭建实现数据互通，全链路覆盖企业生产场景，助力中小企业的数字化转型',
                    img: ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/qxy-bg.png')
                },
                {
                    name: '专属钉钉',
                    tit: '——企业专属、安全、开放的数字化办公',
                    tip: '打造属于企业自己的办公平台，沉淀企业自己的数据资产，打造企业专属品牌，增强员工归属感。专属钉钉是数字化底座，基于混合云部署模式，钉钉基础功能组件部署在阿里公有云专门的VPC中，数据可存储在用户自己的IDC，企业自建应用通过钉钉小程序和H5微应用两种轻量级接入到钉钉开放平台上。',
                    img: ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/dd-bg.png')
                },
                {
                    name: 'Teambition',
                    tit: '——简单好用的项目协同工具',
                    tip: 'Teambition是阿里巴巴集团旗下数字化协作平台，是国内团队协作工具的创导者，通过帮助团队轻松共享和讨论工作中的任务、文件、分享、日程等内容，让团队协作焕发无限可能。Teambition在网页、桌面、移动环境都打造了体验出众的应用，随时随地可以和团队协作。无论是一个标准的项目计划，还是某个职能部门的团队目标，均可在项目空间内，通过可视化方法（流程与步骤、组成部分），文件（经验与资讯）构建整个工作的结构，进而让每位成员都能够形成共识，步调一致，并获得开展工作所需要的资源，从而确保即使不同项目，放置于各地，成员来自不同背景，均能够达到交付质量标准。',
                    img: ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/tea-bg.png')
                },
                {
                    name: 'ChatAI',
                    tit: '——敏捷、高效的项目协同工具',
                    tip: '阿里巴巴Chat AI，是一款基于人工智能技术的聊天机器人，可以与用户进行自然语言交互，回答用户的问题和提供服务。阿里巴巴的Chat AI采用了深度学习技术，可以根据用户的输入和上下文语境进行智能分析和回答，同时也可以进行语音识别和语音合成，实现更加自然和人性化的交互方式。',
                    img: ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/chat-bg.png')
                }

            ],
            faceList: ['校园团餐', '校园智能公话', '校园数智班牌', '校园智能门禁', '校园智慧图书', '校园智慧吹风机', '校园智慧洗衣机', '校园智慧淋浴', '校园自助售货机', '校园智慧饮水机', '校园教育缴费'], // 业务列表
            faceContent: [
                {
                    tit: '校园团餐——助力校园管理优化，推进校园信息化进程',
                    tip: 'CAMPUS GROUP MEAL',
                    con: `<p>校园团餐系统是支付宝联合新域伟科技为线下智慧校园建设中首要目标“智慧餐厅”场景推出的产品，通过人脸对学校的实体卡等身份载体进行升级，实现刷脸吃饭，让校园生活更简单、更智能。</p>
                    <p>新域伟科技基于支付宝平台研发的“新校收收”应用产品，实现人脸采集、人脸识别和支付能力，是目前移动支付领域安全级别最高的支付方式，家长可以通过支付宝实时查看孩子在校消费明细，学生在校消费清清楚楚，增加家长与学校之间的互动点评，培养学生理性消费。</p>
                    <p>系统具备便捷的管理功能，实现食堂报表、整体情况，方便财务后台进行经营统计分析和对账，最终可实现精准备餐/采购、杜绝浪费、提升就餐体验和食堂服务水平的目的，为学校管理者收集多维度数据分析助力学校管理优化，推进校园信息化进程。</p>
                    `,
                },
                {
                    tit: '校园智能公话——一键连接亲情',
                    tip: 'CAMPUS INTELLIGENT PUBLIC TALK',
                    con: `<p>校园智能公话是以可视设备为硬件载体，融合金融级人脸识别技术，通过家校云平台的底座为学生和家长提供音频通话、视频通话、拨号通话等三合一通话方式。依据K12校园特性的需要，增加学生到校刷脸打卡等功能，让家长可实时查看学校通知、学校新闻等校园资讯，助力打造家校互动的数智化校园。</p>
                    `,
                },
                {
                    tit: '校园数智班牌——打造校园文化阵地',
                    tip: 'CAMPUS SMART CLASS CARD',
                    con: `<p>校园数智班牌是学校日常工作、班级文化展示和信息文化交流等校园信息化技术应用的重要载体，是教育信息化区域发展进程中的一个成功的尝试与探索，针对学校文化宣传、教务管理、班级排选课等功能，以班级文化建设为主题，全方位打造校园文化，做到学校日常管理工作完美融合。</p>
                    `,
                },
                {
                    tit: '校园智能门禁——守护校园安全第一线',
                    tip: 'CAMPUS INTELLIGENT ACCESS CONTROL',
                    con: `<p>校园智能门禁是一款便捷、安全的工业级可视人脸识别一体机。针对人脸识别应用过程中存在的大容量、高性能、可定制等方面需求，推出的一款人脸识别智能硬件，可结合人脸识别算法，无需用户配合，实现活体检测、人脸动态识别，为学生提供安全的使用环境，并对学校提供更便捷的一脸通行集成入口。产品采用蚂里奥双目摄像头，支持WIFI+10/100M联网和丰富的外围安防接口，满足学校门禁控制需求，能够实现学生身份验证，学生进出管理和宿舍管理等功能。</p>
                    `,
                },
                {
                    tit: '校园图书借阅——给您非凡的借还体验',
                    tip: 'CAMPUS BOOK BORROWING',
                    con: `<p>智能图书管理系统是一套集功能高效、操作简易、稳定性高于一身的智慧图书管理系统，是专门针对各中小学图书馆自动化管理建设而研发，适用于K12学校及中小型图书馆。</p>
                    <p>产品基于200WRGB+IR双目摄像头，通过人脸识别、入库出库、图书管理等功能，实现图书馆图书采集、编目保存、借阅归还、报表统计、报表查询等自动化管理。</p>
                    `,
                },
                {
                    tit: '校园智慧吹风机——守护校园用电安全',
                    tip: 'CAMPUS SMART HAIR DRYER',
                    con: `<p>校园智慧吹风机在普通吹风机的基础上，加以物联网技术对其进行智能化改造，配合双目摄像头进行人脸识别，学生使用灵活方便并且使用记录可追溯。提供安全、便捷、高性价比的自助电吹风服务。</p>
                    `,
                },
                {
                    tit: '校园智慧洗衣机——您的快洗管家',
                    tip: 'CAMPUS SMART WASHING MACHINE',
                    con: `<p>智慧校园洗衣机,世界领先快洗技术,快洗管家一站式服务模式，专为打造健康智慧校园，创建文明校区而来，干净卫生，质优价低的服务，让学生使用安心，家长放心省心。搭载管理平台，实现洗衣机设备智能化、便捷化管理模式，减轻校园负担。</p>
                    `,
                },
                {
                    tit: '校园智慧淋浴——畅快解压新天地',
                    tip: 'CAMPUS SMART SHOWER',
                    con: `<p>结合3D结构光摄像头创建刷脸支付智慧校园淋浴场景，可自由配置水量、水价，水量用完即停，杜绝浪费水资源，设备端实时显示淋浴状态，杜绝学生无效进入淋浴间，使用随机密码输入方式，快捷高效。</p>
                    `,
                },
                {
                    tit: '校园自助售货机——给您提供健康便捷购物方式',
                    tip: 'CAMPUS SELF-SERVICE VENDING MACHINE',
                    con: `<p>校园智能自助售货机结合人脸识别技术及高清显示屏，让用户拥有更好的交互体验。上架的食品安全健康可控，学生在校刷脸即可购买，消费记录家长可查。且本系统已通过支付宝 K12自助售货机服务商认证， IOT 软件检测、 国家认证检测。给学生提供安全健康便捷的购物方式，给管理者提供灵活智能的管理方式，用科技助力学生健康成长。</p>
                    `,
                },

                {
                    tit: '校园智慧饮水机——您的健康守护者',
                    tip: 'CAMPUS SMART WATER DISPENSER',
                    con: `<p>为切实解决学生饮水卫生安全问题，节约学生时间和费用，一款易管理、易操作、价格合理、方便、快捷、卫生的校园智慧刷脸饮水系统应运而生。多种套餐模式，按需选择；多个接水口，节约用水时间；内置5级精滤系统，保护学生饮水健康。</p>
                    `,
                },
                {
                    tit: '校园教育缴费——让教师统计更方便',
                    tip: 'CAMPUS EDUCATION PAYMENT',
                    con: `<p>极简缴费流程、远程自助缴费、安全、方便、智能、实时到帐，智能多维度金额明细统计，助力科学决策分析;灵活分账，业务不同，功能权限不同，支持系统对接，满足校园收费应用场景。</p>
                    `,
                }
            ],
            faceImgList: [('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/tc-img.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/hj-img.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/bp-img.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/mj-img.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/ts-img.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/cfj-img.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/xyj-img.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/ly-img.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/shj-img.png'),('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/ysj-img.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/jf-img.png'),],
            activePlat: 0, // 字化新平台列表选中索引
            actveFaceIndex: 0, // 业务列表选中索引
            userBox: [
                {
                    userList: [
                        {
                            name: '爱和城高级中学',
                            img: ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/ahc.png'),
                            tipList: [
                                {
                                    tip: '校园团餐',
                                    bg: 'rgba(3,104,254,0.6)'
                                },
                                {
                                    tip: '校园智能门禁',
                                    bg: 'rgba(30,55,217,0.6)'
                                },
                                {
                                    tip: '校园智慧图书',
                                    bg: 'rgba(93,203,137,0.6)'
                                },
                                {
                                    tip: '校园智慧洗衣',
                                    bg: 'rgba(26,122,211,0.6)'
                                }
                            ],
                            id: 'ahc'
                        },
                        {
                            name: '泰兴市第三高级中学',
                            img: ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/txsz.png'),
                            tipList: [
                                {
                                    tip: '校园团餐',
                                    bg: 'rgba(3,104,254,0.6)'
                                },
                                {
                                    tip: '校园智能公话',
                                    bg: 'rgba(34,71,255,0.6)'
                                },
                                {
                                    tip: '校园智慧售货机',
                                    bg: 'rgba(86,110,206,0.6)'
                                },

                                {
                                    tip: '校园智慧洗衣',
                                    bg: 'rgba(26,122,211,0.6)'
                                },
                                {
                                    tip: '校园智慧吹风机',
                                    bg: 'rgba(33,188,103,0.6)'
                                },
                                {
                                    tip: '校园智慧淋浴',
                                    bg: 'rgba(55,187,174,0.6)'
                                }
                            ],
                            id: 'txs'
                        },
                        {
                            name: '长治市文源高级中学',
                            img: ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/cz.png'),
                            tipList: [
                                {
                                    tip: '校园智慧售货机',
                                    bg: 'rgba(86,110,206,0.6)'
                                },
                                {
                                    tip: '校园团餐',
                                    bg: 'rgba(3,104,254,0.6)'
                                },
                                {
                                    tip: '校园智能公话',
                                    bg: 'rgba(34,71,255,0.6)'
                                }
                            ],
                            id: 'czs'
                        }
                    ],
                },
                {
                    userList: [
                        {
                            name: '修文县第五小学',
                            img: ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/caseUser/xwx.png'),
                            tipList: [
                                {
                                    tip: '教育缴费',
                                    bg: 'rgba(3,104,254,0.6)'
                                },
                            ],
                            id: 'xwx'
                        },
                        {
                            name: '淮安市城北开明中学',
                            img: ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/caseUser/hascb.png'),
                            tipList: [
                                {
                                    tip: '校园团餐',
                                    bg: 'rgba(3,104,254,0.6)'
                                },
                                {
                                    tip: '校园智能公话',
                                    bg: 'rgba(34,71,255,0.6)'
                                }
                            ],
                            id: 'hasb'
                        },
                        {
                            name: '淮安高新区高级中学',
                            img: ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/caseUser/hascbgj.png'),
                            tipList: [
                                {
                                    tip: '校园团餐',
                                    bg: 'rgba(3,104,254,0.6)'
                                },
                                {
                                    tip: '校园智能公话',
                                    bg: 'rgba(34,71,255,0.6)'
                                }
                            ],
                            id: 'hagx'
                        }
                    ],
                },
                {
                    userList: [
                        {
                            name: '重庆应用技术职业学院',
                            img: ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/caseUser/cqxy.png'),
                            tipList: [
                                {
                                    tip: '校园智能门禁',
                                    bg: 'rgba(30,55,217,0.6)'
                                }
                            ],
                            id: 'cq'
                        },
                        {
                            name: '淮安市淮海中学',
                            img: ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/caseUser/hhzx.png'),
                            tipList: [
                                {
                                    tip: '校园团餐',
                                    bg: 'rgba(3,104,254,0.6)'
                                },
                                {
                                    tip: '校园智能公话',
                                    bg: 'rgba(34,71,255,0.6)'
                                }
                            ],
                            id: 'has'
                        },
                        {
                            name: '济南市第二十七中学',
                            img: ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/caseUser/jn27.png'),
                            tipList: [
                                {
                                    tip: '校园数智班牌',
                                    bg: 'rgba(1,122,170,0.6)'
                                }
                            ],
                            id: 'jns'
                        }
                    ],
                }
            ],

            userTabIndex: 0, // 用户索引
            partnerList1: [{
                src: "https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/hw.png, https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/ali.png, https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/dd-p.png, https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/zfb.png"
            }], // 合作伙伴列表
            partnerList: [('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/hw.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/ali.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/dd-p.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/zfb.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/wx.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/qywx.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/dx.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/yd.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/lt.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/payh.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/jtyh.png'), ('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/bbbs.png')], // 合作伙伴列表
        }
    },
    methods: {
        // 产品介绍跳转
        goProductDetail() {
            this.$router.push({ name: "productDetail" });
        },
        // 字化新平台列表选择
        platClick(index) {
            this.activePlat = index
        },
        // 教育、政企产品详情跳转
        goEduCase(proIndex, index) {
            this.$router.push({
                name: "productDetail",
                query: {
                    proIndex,
                    eduCaseIndex: index
                }
            });
        },
        // 学校点击
        userItemClick(val, index) {
            this.$router.push({ name: "caseEducation", query: { key: val.id, index: 0 } });
        },
        // 业务列表选择
        faceItemClick(index) {
            this.actveFaceIndex = index
        },
        dialogClose() {
            this.dialogVisible = false
            sessionStorage.setItem('dialogVisible', 1)
        },
        // 用户切换
        // userTabClick(index) {
        //     this.userTabIndex = index
        // },
    },
    created() {
        console.log(3);
        this.dialogVisible = sessionStorage.getItem('dialogVisible') ? false : true
    },
    mounted() {
        document.documentElement.scrollTop = 0;
    },
    computed: {
        classOption() {
            return {
                direction: 2,
                limitMoveNum: 0,
                step: .5
            }
        },
        classOption2() {
            return {
                direction: 2,
                limitMoveNum: 0,
                step: 1
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.seamless-warp {
    overflow: hidden;
    height: 110px;
    width: 1580px;
    margin: auto;

    ul.item {
        width: 1366px;
        height: 77px;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
            // float: left;
            // margin-right: 10px;
        }
    }
}

/* 修改滚动条的宽度和颜色 */
::-webkit-scrollbar {
    width: 10px;
    background-color: #EEF3FF;
}

/* 修改滚动条滑块的样式 */
::-webkit-scrollbar-thumb {
    background-color: #D6E2FF;
    border-radius: 8px;
    /* 修改滑块圆角 */
}

/* 修改滚动条滑块悬停时的样式 */
::-webkit-scrollbar-thumb:hover {
    background-color: #85a9f1;
}

.test {
    width: 100px;
    height: 100px;
    background: #000;
}


.slider_img {
    height: 550px;
    width: 100%;
}

/* banner */
.banner {
    position: relative;
    height: 701px;
    /* background: url('../static/imgs/home.png'); */
    background: url('https://xyw-bucket-prod.oss-cn-hangzhou.aliyuncs.com/website/assets/home.png') no-repeat;
    background-size: cover;
    overflow: hidden;

    .b-left {
        margin: 219px 0 0 260px;

        .b-tit {
            font-size: 36px;
            color: #0267FE;
            line-height: 50px;
            font-weight: 700;
        }

        .b-tip {
            font-size: 14px;
            line-height: 20px;
            color: #333;
            margin: 20px 0 44px 0;
        }

        .b-detail {
            width: 134px;
            height: 47px;
            line-height: 47px;
            background: #0267FE;
            border-radius: 6px;
            color: #fff;
            font-size: 18px;
            text-align: center;
            cursor: pointer;

            &:active {
                opacity: .5;
            }
        }
    }

    .b-img {
        position: absolute;
        top: 93px;
        right: 305px;
        width: 484px;
        height: 484px;
    }
}

/* 数字平台 */
.digital-platform {
    height: 994px;
    background: url('../assets/bg-plat.png') no-repeat;
    background-size: cover;
    overflow: hidden;


    .plat-tit {
        margin: 120px 0 35px 0;
        text-align: center;
        font-size: 28px;
        color: #242424;
        font-weight: 700;
    }

    .plat-list {
        display: flex;
        justify-content: center;
        font-size: 20px;
        color: #242424;
        margin-bottom: 59px;

        .plat-item {
            display: flex !important;
            width: 209px;
            height: 50px;
            justify-content: center !important;
            align-items: center;
            margin-right: 50px;
            cursor: pointer;

            img {
                width: 36px;
                height: 36px;
            }
        }

        .p-i-ac {
            width: 209px;
            height: 50px;
            background: #0267FE;
            color: #fff;
            border-radius: 143px;
        }
    }

    .plat-content {
        display: flex;
        justify-content: center;

        .plat-left {
            margin-right: 74px;

            img {
                width: 850px;
                height: 590px;
            }
        }

        .plat-right {
            width: 476px;
            margin-top: 80px;

            .p-r-tit {
                font-size: 28px;
                color: #242424;
                font-weight: 700;
            }

            .p-r-tip {
                font-size: 14px;
                color: #666;
                margin: 24px 0 150px 0;
            }

            .b-detail {
                width: 134px;
                height: 47px;
                line-height: 47px;
                background: #0267FE;
                border-radius: 6px;
                color: #fff;
                font-size: 18px;
                text-align: center;
                cursor: pointer;

                &:active {
                    opacity: .5;
                }
            }
        }
    }
}

/* 一脸通行 */
.face-box {
    height: 860px;
    background-color: #F3F7FF;
    overflow: hidden;

    .f-tit {
        margin: 120px 0 40px 0;
        text-align: center;
        font-size: 28px;
        color: #333;
        font-weight: 700;
    }

    .f-con {
        height: 100%;
        display: flex;
        justify-content: center;

        .f-left {
            position: relative;
            width: 220px;
            height: 560px;
            background: #EEF3FF;
            border-radius: 16px;
            color: #333;
            padding: 0 16px;
            box-sizing: border-box;

            .f-l-tit {
                position: sticky;
                width: 170px;
                top: 0;
                height: 84px;
                line-height: 84px;
                text-align: center;
                font-size: 20px;
                font-weight: 700;
                background-color: #EEF3FF;
            }

            .f-l-list {
                height: 430px;
                overflow-x: hidden;
                overflow-y: auto;

                .f-l-item {
                    width: 168px;
                    height: 48px;
                    line-height: 48px;
                    font-size: 16px;
                    margin-bottom: 8px;
                    cursor: pointer;
                    padding-left: 24px;
                    box-sizing: border-box;
                }
            }

            .face-ac {
                color: #fff;
                background: #0267FE;
                border-radius: 143px;
            }
        }

        .f-center {
            position: relative;
            width: 710px;
            height: 560px;
            background: #EEF3FF;
            border-radius: 16px;
            margin: 0 16px 0 16px;

            .f-c-t {
                height: 126px;
                background-color: #DEE9FF;
                padding: 32px 32px 26px 32px;
                box-sizing: border-box;
                border-radius: 16px 16px 0px 0px;

                .f-c-t-tit {
                    font-size: 24px;
                    color: #333;
                    font-weight: 700;
                    margin-bottom: 14px;
                    border-radius: 16px 16px 0px 0px;
                }

                .f-c-t-tip {
                    font-size: 14px;
                    color: #666;
                }
            }

            .f-c-c {
                padding: 28px;
                box-sizing: border-box;
                font-size: 14px;
                color: #666;
            }

            .b-detail {
                position: absolute;
                left: 32px;
                bottom: 65px;
                width: 134px;
                height: 47px;
                line-height: 47px;
                background: #0267FE;
                border-radius: 6px;
                color: #fff;
                font-size: 18px;
                text-align: center;
                cursor: pointer;
                margin: 54px 0 0 32px;

                &:active {
                    opacity: .5;
                }
            }
        }

        .f-r {
            width: 458px;
            height: 560px;
            object-fit: contain;
        }
    }
}

/* 认可 */
.user-box {

    .user-tit {
        margin: 120px 0 57px 0;
        text-align: center;
        text-align: center;
        font-size: 28px;
        color: #333;
        font-weight: 700;
    }

    .user-list-box {
        width: 1400px;
        margin: auto;
        // height: 367px;

        .user-list {
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            // margin-top: 25px;
            margin: auto;

            .user-item {
                position: absolute;
                top: 15px;

                &:nth-child(1) {
                    left: 0;
                }

                &:nth-child(2) {
                    left: 48.5%;
                    transform: translateX(-50%);
                }

                &:nth-child(3) {
                    right: 0;
                }

                width: 440px;
                height: 367px;
                box-shadow: 0px 4px 10px 0px rgba(3, 104, 254, 0.1);
                border-radius: 8px;
                margin: 0 20px;
                cursor: pointer;

                img {
                    width: 100%;
                    height: 235px;
                    object-fit: contain;
                }

                .tip-list {
                    display: flex;
                    flex-wrap: wrap;
                    margin-left: 24px;
                    margin-top: 10px;

                    .tip-item {
                        text-align: center;
                        margin: 0 4px 11px;
                        width: 99px;
                        height: 19px;
                        line-height: 19px;
                        padding: 0 6px;
                        box-sizing: border-box;
                        color: #fff;
                        font-size: 12px;
                        margin-right: 8px;
                    }
                }

                .user-name {
                    margin: 13px 0 0 24px;
                    font-size: 20px;
                    color: #333;
                    font-weight: 700;
                }

                &:hover {
                    top: 0px;
                    transition: all .4s;
                }
            }

            // .user-item-c {
            //     margin: 0 20px 10px !important;
            // }
        }
    }

    .user-tabs {
        display: flex;
        justify-content: center;
        margin-top: 76px;

        .tab {
            width: 60px;
            height: 10px;
            background: #F3F7FF;
            border-radius: 22px;
            cursor: pointer;
            margin-right: 40px;
        }

        .user-tab {
            background: #0267FE;
        }
    }
}

/* 合作伙伴 */
.partner-box {
    margin-bottom: 80px;

    .partner-tit {
        font-size: 28px;
        color: #333;
        font-weight: 700;
        text-align: center;
        margin: 120px 0 50px 0;
    }

    .partner-list {
        width: 1450px;
        // flex-wrap: wrap;
        display: flex;
        justify-content: center;
        margin: 0 auto 80px;

        .partner-item {
            display: flex;
            flex-shrink: 0;
            width: 186px;
            height: 77px;
            margin-right: 50px;
            margin-bottom: 30px;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
    }
}

.dia-log {

    // position: relative;
    .dia-log-img {
        width: 100%;
        height: 100%;
    }

    .close-img {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: 47px;
        width: 63px;
        height: 63px;
        cursor: pointer;
    }
}

::v-deep .el-dialog {
    width: 1244px !important;
    background: transparent;
    box-shadow: unset;
}

::v-deep .el-dialog__header {
    padding: 0;
}

::v-deep .el-dialog__body {
    padding: 0;
    height: 716px;
}

// ::v-deep .el-carousel {
//     position: relative;
//     width: 1400px;
//     margin: auto;
// }

::v-deep .el-carousel__indicators {
    // background-color: red;
    margin-top: 20px;

    .el-carousel__indicator {
        .el-carousel__button {
            width: 60px;
            height: 10px;
            border-radius: 22px;
            background-color: #ccc;
        }

    }

    .is-active {
        .el-carousel__button {
            background-color: #0267FE;
        }
    }
}

::v-deep .el-carousel__container {
    height: 400px;
}
</style>
